// extracted by mini-css-extract-plugin
export var button = "_60-4";
export var hasDarkBackground = "_60-7";
export var hasLightBackground = "_60-6";
export var iconWrapper = "_60-0";
export var large = "_60-2";
export var medium = "_60-1";
export var small = "_60-5";
export var xsmall = "_60-3";